<template>
  <div class="custom-card">
    <v-card outlined class="programa-universidad-card">
      <v-card-title class="programa-universidad-header">
        <v-icon color="primary" class="mr-2">mdi-school-outline</v-icon>
        <span class="text-subtitle-1 font-weight-bold mr-2">Programa Universidad</span>

        <v-switch
          v-if="this.$store.state.CARGO.id == 1"
          v-model="mostrarTodasSedes"
          hide-details
          dense
          inset
          label="Ver todos"
          class="mt-0 pt-0"></v-switch>

        <v-spacer />

        <span class="caption grey--text text--darken-1 mr-2">{{ textoPaginacion }}</span>

        <v-select
          :items="[10, 25, 50, 75, 100, 500]"
          label="Por página"
          v-model="itemsPorPagina"
          outlined
          dense
          hide-details
          class="programa-universidad-items-pagina mr-2"
          :disabled="items.length == 0"
          @change="cambiarPagina" />

        <v-pagination
          class="custom-pagination"
          v-model="pagina"
          :length="metadatos?.totalPaginas || 0"
          :total-visible="7"
          @input="listar"></v-pagination>
      </v-card-title>

      <v-divider class="my-1" />

      <v-card-text class="programa-universidad-filtros">
        <v-row dense align="center">
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-select
              v-model="estadoProgramaUniversidad"
              :items="[
                { value: null, text: 'Todos' },
                { value: 'inscrito', text: 'Inscrito' },
                { value: 'pendiente', text: 'Pendiente de Inscripción' },
              ]"
              label="Estado"
              outlined
              dense
              hide-details
              @change="listarRestableciendoPagina">
            </v-select>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="2">
            <v-select
              v-model="tieneModulos"
              :items="[
                { value: null, text: 'Todos' },
                { value: true, text: 'Sí' },
                { value: false, text: 'No' },
              ]"
              label="Tiene Módulos"
              outlined
              dense
              hide-details
              @change="listarRestableciendoPagina">
            </v-select>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="2">
            <v-select
              v-model="tienePlanPago"
              :items="[
                { value: null, text: 'Todos' },
                { value: true, text: 'Sí' },
                { value: false, text: 'No' },
              ]"
              label="Tiene Plan de Pago"
              outlined
              dense
              hide-details
              @change="listarRestableciendoPagina">
            </v-select>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="3">
            <v-select
              v-model="sedeUniversidadId"
              :items="sedesUniversidades"
              item-text="nombre"
              item-value="id"
              label="Sede Universidad"
              outlined
              dense
              hide-details
              clearable
              @change="listarRestableciendoPagina">
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">{{ item.nombre }}</v-list-item-title>
                  <v-list-item-subtitle class="subtitle-2 text-uppercase">
                    <small>{{ item.institucion.nombre }}</small>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-select>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="3">
            <v-text-field
              dense
              outlined
              hide-details
              v-model="searchQuery"
              append-icon="mdi-magnify"
              label="Buscar"
              clearable
              @input="buscar"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-1" />

      <v-toolbar flat color="grey lighten-4" class="programa-universidad-toolbar">
        <template v-if="tipo == tiposProgramasUniversidadesLayouts.NACIONAL && permisosAcademicosNacional">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1"
                fab
                dark
                x-small
                color="primary"
                v-bind="attrs"
                v-on="on"
                :disabled="!versionFormularioProgramaUniversidad"
                @click="abrirModalFormularioProgramaUniversidad(accionesCrud.REGISTRAR, [])">
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Registrar</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1"
                fab
                x-small
                v-bind="attrs"
                v-on="on"
                :disabled="item == null || !versionFormularioProgramaUniversidad"
                @click="abrirModalFormularioProgramaUniversidad(accionesCrud.EDITAR, item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1"
                fab
                dark
                x-small
                color="error"
                v-bind="attrs"
                v-on="on"
                :disabled="item == null"
                @click="
                  () =>
                    confirmacionAccion(accionesAConfirmar.ELIMINAR, nombreItem, `${item.codigo} ${item.programaNombre}`)
                ">
                <v-icon dark>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Eliminar</span>
          </v-tooltip>

          <v-divider vertical class="mx-1 my-1" />
        </template>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-1"
              fab
              x-small
              v-bind="attrs"
              v-on="on"
              :disabled="item == null"
              @click="$refs.modalMostrarProgramaUniversidadRef.abrir(item)">
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
          <span>Ver</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-1"
              fab
              x-small
              v-bind="attrs"
              v-on="on"
              :disabled="item == null"
              :loading="descargandoPdf"
              @click="obtenerPdfProgramaUniversidad">
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
          </template>
          <span>Ver PDF</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mx-1" fab x-small v-bind="attrs" v-on="on" @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Recargar</span>
        </v-tooltip>

        <template v-if="tipo == tiposProgramasUniversidadesLayouts.NACIONAL && permisosAcademicosNacional">
          <v-divider vertical class="mx-1 my-1" />

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1"
                fab
                dark
                x-small
                color="success"
                v-bind="attrs"
                v-on="on"
                :disabled="
                  item == null ||
                  [
                    estadosProgramasUniversidades.INSCRITO,
                    estadosProgramasUniversidades.NO_EJECUTADO_DISPONIBLE,
                  ].includes(item.estado)
                "
                @click="confirmarConsolidacion">
                <v-icon dark>mdi-check-decagram</v-icon>
              </v-btn>
            </template>
            <span>Consolidar</span>
          </v-tooltip>
        </template>

        <v-spacer />

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text small v-bind="attrs" v-on="on">
              <v-icon left small>mdi-dots-vertical</v-icon>
              Más acciones
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item
              v-if="permisosAcademicosNacional || permisosPresupuestos1 || permisosContabilidadNacional"
              :disabled="item == null"
              @click="$refs.modalFormEstablecerPlanPagoProgramaUniversidadRef.abrir(item)">
              <v-list-item-icon><v-icon>mdi-cash</v-icon></v-list-item-icon>
              <v-list-item-title>Plan de Pago</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="permisosAcademicosNacional"
              :disabled="item == null"
              @click="$refs.modalFormAgregarCEUBRef.abrir(item)">
              <v-list-item-icon><v-icon>mdi-file-document</v-icon></v-list-item-icon>
              <v-list-item-title>Documento CEUB</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="permisosAcademicosNacional"
              :disabled="item == null"
              @click="$refs.modalFormAgregarCarpetaAcademicaRef.abrir(item)">
              <v-list-item-icon><v-icon>mdi-folder-account</v-icon></v-list-item-icon>
              <v-list-item-title>Carpeta Académica</v-list-item-title>
            </v-list-item>

            <v-list-item
              :disabled="item == null"
              @click="$refs.modalMostrarProgramasRef.abrir(accionesCrud.EDITAR, item)">
              <v-list-item-icon><v-icon>mdi-file-document-multiple-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Programas</v-list-item-title>
            </v-list-item>

            <v-list-item
              :disabled="item == null"
              @click="$refs.modalInscripcionesProgramaUniversidadRef.abrir(accionesCrud.EDITAR, item)">
              <v-list-item-icon><v-icon>mdi-file-document-multiple-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Inscripciones Programa Univ.</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="
                permisosPresupuestos1 ||
                permisosPresupuestos2 ||
                permisosGestionEmpresarial ||
                permisosContabilidadNacional ||
                permisosAcademicosNacional
              "
              :disabled="item == null || item.estado !== estadosProgramasUniversidades.INSCRITO"
              @click="handleSolcitudesPagos">
              <v-list-item-icon><v-icon>mdi-text-box-multiple-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Solicitudes de Pago</v-list-item-title>
            </v-list-item>

            <v-list-item
              :disabled="item == null || item.programas.length === 0"
              @click="$refs.modalVisualizarInscripcionesRef.abrir(accionesCrud.EDITAR, item)">
              <v-list-item-icon><v-icon>mdi-school</v-icon></v-list-item-icon>
              <v-list-item-title>Inscripciones de Programas Vinculados</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y v-if="permisosAcademicosNacional">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              small
              v-bind="attrs"
              v-on="on"
              :loading="descargandoExcel">
              <v-icon left small>mdi-file-excel-outline</v-icon>
              Exportar
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item :disabled="descargandoExcel" @click="obtenerExcelProgramasUniversidades">
              <v-list-item-icon><v-icon>mdi-file-excel</v-icon></v-list-item-icon>
              <v-list-item-title>Programas Universidad</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>

      <v-divider class="my-1" />

      <v-card-text class="programa-universidad-grid">
        <ListadoProgramaUniversidad ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
      </v-card-text>
    </v-card>

    <ModalFormularioProgramaUniversidad ref="modalFormularioProgramaUniversidadRef" @actualizarListado="listar" />

    <ModalFormularioProgramaUniversidadV2 ref="modalFormularioProgramaUniversidadV2Ref" @actualizarListado="listar" />

    <ConfirmacionAccion
      ref="confirmacionRef"
      max-width="1200"
      :titulo="confirmacion.titulo"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="confirmacion.fnAceptar">
      <template>
        <p v-html="confirmacion.mensaje"></p>

        <v-alert v-if="!inscritosReportadosProgramaUniversidad" class="font-weight-bold mt-4" type="error" dense>
          No hay programas vinculados con inscripciones reportadas para el Programa Universidad seleccionado.
        </v-alert>

        <v-simple-table v-else dense>
          <thead>
            <th>ID Programa</th>
            <th>Programa</th>
            <th>Inscritos</th>
            <th>Reportado Por</th>
            <th>Reportado En</th>
          </thead>

          <tbody>
            <tr v-for="programa in inscritosReportadosProgramaUniversidad.programas" :key="programa.id">
              <td width="100">{{ programa.id }}</td>
              <td>{{ programa.nombreCompuesto }}</td>
              <td width="80">{{ programa.cantidadInscritos }}</td>
              <template v-if="!programa.programaReportado">
                <td colspan="2" class="text-center" width="400">No reportado</td>
              </template>

              <template v-else>
                <td width="250">{{ programa.programaReportado.reportadoPor }}</td>
                <td width="150">
                  {{
                    new Date(programa.programaReportado.creadoEn).toLocaleString('es-BO', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                      second: '2-digit',
                    })
                  }}
                </td>
              </template>
            </tr>

            <tr>
              <td colspan="2" class="font-weight-bold text-right">Total Inscritos Reportados:</td>
              <td class="font-weight-bold">{{ totalInscritosReportados }}</td>
              <td colspan="2"></td>
            </tr>
          </tbody>
        </v-simple-table>
      </template>
    </ConfirmacionAccion>

    <ModalInscripcionesProgramaUniversidad ref="modalInscripcionesProgramaUniversidadRef" :nombreRecurso="nombreItem" />

    <ModalSolicitudesPagos ref="modalSolicitudesPagosRef" :nombreRecurso="nombreItem2" />

    <ModalCostosPrograma ref="modalCostosProgramaRef" :nombreRecurso="nombreItem3" @actualizarListado="listar" />

    <ModalMostrarProgramas ref="modalMostrarProgramasRef" :nombreRecurso="nombreItem4" />

    <ModalModulosPrograma ref="modalModulosProgramaRef" :nombreRecurso="nombreItem5" @actualizarListado="listar" />

    <ModalMostrarProgramaUniversidadV2 ref="modalMostrarProgramaUniversidadRef" />

    <ModalFormEstablecerPlanPagoProgramaUniversidad
      ref="modalFormEstablecerPlanPagoProgramaUniversidadRef"
      @actualizarListado="listar" />

    <ModalFormAgregarCEUB ref="modalFormAgregarCEUBRef" @actualizarListado="listar" />

    <ModalFormAgregarCarpetaAcademica ref="modalFormAgregarCarpetaAcademicaRef" @actualizarListado="listar" />

    <ModalVisualizarInscripciones
      ref="modalVisualizarInscripcionesRef"
      :universidadId="item?.sedeUniversidad?.universidadId"
      nombreRecurso="Inscripciones de Programas Vinculados" />

    <ModalVerPdf ref="modalVerPdfRef" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import ListadoProgramaUniversidad from '../components/ListadoProgramaUniversidad.vue';
import ModalFormularioProgramaUniversidadV2 from '../components/ProgramaUniversidad/ModalFormularioProgramaUniversidadV2.vue';
import ProgramaUniversidadService from '../services/programa-universidad.service';
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import ModalInscripcionesProgramaUniversidad from '../components/ModalInscripcionesProgramaUniversidad.vue';
import ModalSolicitudesPagos from '../components/ModalSolicitudesPagos.vue';
import ModalCostosPrograma from '../components/ModalCostosPrograma.vue';
import { ESTADOS_PROGRAMAS_UNIVERSIDADES, TIPOS_PROGRAMAS_UNIVERSIDADES_LAYOUTS } from '../utils/constantes';
import ModalMostrarProgramas from '../components/ModalMostrarProgramas.vue';
import ModalModulosPrograma from '../components/ModalModulosPrograma.vue';
import ModalMostrarProgramaUniversidadV2 from '../components/ProgramaUniversidad/ModalMostrarProgramaUniversidadV2.vue';
import ModalFormEstablecerPlanPagoProgramaUniversidad from '../components/ModalFormEstablecerPlanPagoProgramaUniversidad.vue';
import SedeUniversidadService from '../services/sede-universidad.service';
import { mapGetters } from 'vuex';
import ModalFormAgregarCEUB from '../components/ModalFormAgregarCEUB.vue';
import ModalFormAgregarCarpetaAcademica from '../components/ModalFormAgregarCarpetaAcademica.vue';
import ProgramaUniversidadExcelService from '../services/programa-universidad-excel.service';
import ModalVisualizarInscripciones from '../components/ModalVisualizarInscripciones.vue';
import ModalVerPdf from '../components/ModalVerPdf.vue';
import ProgramaUniversidadPdfV2Service from '../services/programa-universidad-pdf-v2.service';
import ModalFormularioProgramaUniversidad from '../components/ModalFormularioProgramaUniversidad.vue';

export default {
  name: 'ProgramaUniversidadLayout',
  mixins: [layoutMixin, apiConsumerMixin],
  components: {
    ListadoProgramaUniversidad,
    ModalFormularioProgramaUniversidadV2,
    ModalInscripcionesProgramaUniversidad,
    ModalSolicitudesPagos,
    ModalCostosPrograma,
    ModalMostrarProgramas,
    ModalModulosPrograma,
    ModalFormularioProgramaUniversidad,
    ModalMostrarProgramaUniversidadV2,
    ModalFormEstablecerPlanPagoProgramaUniversidad,
    ModalFormAgregarCEUB,
    ModalFormAgregarCarpetaAcademica,
    ModalVisualizarInscripciones,
    ModalVerPdf,
  },
  props: {
    tipo: {
      type: String,
      required: true,
      validator: (value) => Object.values(TIPOS_PROGRAMAS_UNIVERSIDADES_LAYOUTS).includes(value),
    },
  },
  created() {
    this.$store.dispatch('pago/setFiltrarPorSede', this.tipo === TIPOS_PROGRAMAS_UNIVERSIDADES_LAYOUTS.SEDE);
    this.obtenerSedesUniversidades();
  },
  data() {
    return {
      nombreItem: 'Programa Universidad',
      nombreItem2: 'Solicitud Pago',
      nombreItem3: 'Costos Programa',
      nombreItem4: 'Programas',
      nombreItem5: 'Módulos Programa',
      tiposProgramasUniversidadesLayouts: TIPOS_PROGRAMAS_UNIVERSIDADES_LAYOUTS,
      estadosProgramasUniversidades: ESTADOS_PROGRAMAS_UNIVERSIDADES,
      sedesUniversidades: [],
      sedeUniversidadId: null,
      estadoProgramaUniversidad: null,
      mostrarTodasSedes: false,
      descargandoExcel: false,
      inscritosReportadosProgramaUniversidad: null,
      tieneModulos: null,
      tienePlanPago: null,
      descargandoPdf: false,
    };
  },
  mounted() {
    this.listar();
  },
  watch: {
    '$store.state.CARGO.sede.id'() {
      this.sedeUniversidadId = null;
      this.obtenerSedesUniversidades();

      if (!this.mostrarTodasSedes) {
        this.listarRestableciendoPagina();
      }
    },
    mostrarTodasSedes() {
      this.sedeUniversidadId = null;
      this.obtenerSedesUniversidades();
      this.listarRestableciendoPagina();
    },
    item(value) {
      if (value) {
        this.obtenerInscritosReportados();
      }
    },
    '$store.state.convenio.id'() {
      this.listarRestableciendoPagina();
    },
  },
  computed: {
    ...mapGetters({
      permisosPresupuestos1: 'presupuesto/permisosPresupuestos1',
      permisosPresupuestos2: 'presupuesto/permisosPresupuestos2',
      permisosAcademicosNacional: 'pago/permisosAcademicosNacional',
      permisosGestionEmpresarial: 'pago/permisosGestionEmpresarial',
      permisosContabilidadNacional: 'pago/permisosContabilidadNacional',
    }),
    totalInscritosReportados() {
      if (!this.inscritosReportadosProgramaUniversidad) {
        return 0;
      }

      return this.inscritosReportadosProgramaUniversidad.programas.reduce(
        (total, programa) => total + Number(programa.cantidadInscritos),
        0,
      );
    },
    textoPaginacion() {
      return `Mostrando ${
        this.metadatos?.totalItems === 0 ? 0 : (this.metadatos?.paginaActual - 1) * this.metadatos?.itemsPorPagina + 1
      } - ${Math.min(
        this.metadatos?.paginaActual * this.metadatos?.itemsPorPagina,
        this.metadatos?.totalItems || 0,
      )} de ${this.metadatos?.totalItems || 0} Registros`;
    },
    versionFormularioProgramaUniversidad() {
      const convenioId = this.$store.state.convenio.id;

      if (convenioId === 49) return 'v1'; // Universidad de Pando
      if (convenioId === 9 || convenioId === 20) return 'v2'; // Siglo XX, Ballivián

      return null;
    },
  },
  methods: {
    abrirModalFormularioProgramaUniversidad(accion, data) {
      if (this.versionFormularioProgramaUniversidad === 'v1') {
        this.$refs.modalFormularioProgramaUniversidadRef.abrir(accion, data);
      } else if (this.versionFormularioProgramaUniversidad === 'v2') {
        this.$refs.modalFormularioProgramaUniversidadV2Ref.abrir(accion, data);
      }
    },
    listar() {
      const params = {
        pagina: this.pagina,
        itemsPorPagina: this.itemsPorPagina,
        busqueda: this.busqueda,
        sedeUniversidadId: this.sedeUniversidadId,
        estado: this.estadoProgramaUniversidad,
        sedeId: this.mostrarTodasSedes ? null : this.$store.state.CARGO.sede.id,
        tieneModulos: this.tieneModulos,
        tienePlanPago: this.tienePlanPago,
        universidadId: this.$store.state.convenio.id,
      };

      this.obtenerDatosPaginadosConNotificacion(
        ProgramaUniversidadService.findAllPaginado,
        'items',
        'metadatos',
        this.nombreItem,
        params,
      );

      this.item = null;
    },
    async getResponseAccion(accion) {
      let response = null;

      if (accion === this.accionesAConfirmar.ELIMINAR) {
        response = await ProgramaUniversidadService.remove(this.item.id);
      }

      return response;
    },
    confirmarConsolidacion() {
      this.confirmacion.titulo = 'Consolidar';
      this.confirmacion.mensaje = /*html*/ `¿Está seguro de consolidar el Programa Universidad?
      Al consolidar, se generará el Código de Empastado
      También, <strong>No se permitirá:</strong>
      <ul>
        <li>Modificar o Eliminar el Programa Universidad</li>
        <li>Realizar Solicitudes de Inscripción</li>
        <li>Realizar Inscripciones</li>
      </ul>
      Por el contrario, <strong>Sí se permitirá</strong>:
      <ul>
        <li>Realizar Solicitudes de Pago</li>
        <li>Realizar Pagos</li>
      </ul>`;
      this.confirmacion.fnAceptar = () => this.consolidar();
      this.$refs.confirmacionRef.abrir();
    },
    async consolidar() {
      this.confirmacion.realizandoAccion = true;

      try {
        const { data } = await ProgramaUniversidadService.consolidar(this.item.id);

        this.$refs.confirmacionRef.cerrar();
        this.listar();
        this.$notify({
          group: 'notifications',
          title: this.nombreItem.toUpperCase(),
          text: data?.mensaje || 'Programa Universidad consolidado correctamente',
          type: 'success',
        });
      } catch (error) {
        window.console.log({ error });
        const data = error?.response?.data;
        const mensaje = data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: this.nombreItem.toUpperCase(),
          text: mensaje || 'Error al consolidar Programa Universidad',
          type: 'error',
        });
      } finally {
        this.confirmacion.realizandoAccion = false;
      }
    },
    async obtenerSedesUniversidades() {
      await this.obtenerDatosMixin(SedeUniversidadService.findAll, 'sedesUniversidades', {
        sedeId: this.mostrarTodasSedes ? null : this.$store.state.CARGO.sede.id,
      });
    },
    handleSolcitudesPagos() {
      if (!this?.item?.planPagoUniversidadId) {
        this.$notify({
          group: 'notifications',
          title: 'Error: Plan de Pago',
          text: 'Debe asignar un plan de pago al Programa Universidad',
          type: 'error',
        });

        return;
      }

      this.$refs.modalSolicitudesPagosRef.abrir(this.accionesCrud.EDITAR, this.item);
    },
    async obtenerExcelProgramasUniversidades() {
      this.descargandoExcel = true;

      const params = {
        sedeId: this.mostrarTodasSedes ? null : this.$store.state.CARGO.sede.id,
      };

      try {
        const response = await ProgramaUniversidadExcelService.findAll({ params });
        const data = response.data;
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');

        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', 'programas_nacionales.xlsx');
        document.body.appendChild(link);
        link.click();

        this.$notify({
          group: 'notifications',
          title: 'Exportación exitosa',
          text: 'Programas Universidad exportados correctamente',
          type: 'success',
        });
      } catch (error) {
        window.console.error(error);

        this.$notify({
          group: 'notifications',
          title: 'Error al exportar',
          text: 'No se pudo exportar los programas universidad',
          type: 'error',
        });
      } finally {
        this.descargandoExcel = false;
      }
    },
    async obtenerInscritosReportados() {
      this.inscritosReportadosProgramaUniversidad = null;

      try {
        const params = {
          codigos: `${this.item.codigo}`,
        };

        const response = await ProgramaUniversidadService.inscritosReportados({ params });
        const data = response?.data;
        const datos = data?.datos || [];

        this.inscritosReportadosProgramaUniversidad = datos && datos.length > 0 ? datos[0] : null;
      } catch (error) {
        window.console.log({ error });
        const data = error?.response?.data;
        const mensaje = data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: this.nombreItem.toUpperCase(),
          text: mensaje || 'Error al obtener inscritos reportados',
          type: 'error',
        });
      }
    },
    async obtenerPdfProgramaUniversidad() {
      this.descargandoPdf = true;

      try {
        const response = await ProgramaUniversidadPdfV2Service.findOne(this.item.id, {
          params: { formato: 'base64' },
        });
        const base64 = response.data.datos;
        const blob = new Blob([Buffer.from(base64, 'base64')], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);

        this.$refs.modalVerPdfRef.abrir(url);
      } catch (error) {
        window.console.error(error);
        const mensaje = error?.response?.data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: this.nombreItem.toUpperCase(),
          text: mensaje || 'Error al obtener el PDF del Programa Universidad',
          type: 'error',
        });
      } finally {
        this.descargandoPdf = false;
      }
    },
  },
};
</script>

<style scoped>
.custom-card {
  margin: 0px 8px 0px 8px;
}

.programa-universidad-card {
  border-radius: 8px;
}

.programa-universidad-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
}

.programa-universidad-filtros {
  padding: 8px 16px 4px;
}

.programa-universidad-grid {
  padding: 4px 8px;
}

.programa-universidad-toolbar {
  flex-wrap: wrap;
  height: auto !important;
  padding: 0 8px;
}

::v-deep .programa-universidad-toolbar .v-toolbar__content {
  flex-wrap: wrap;
  height: auto !important;
  padding: 2px 0;
}

.programa-universidad-items-pagina {
  max-width: 140px;
}

::v-deep .custom-pagination .v-pagination__item,
::v-deep .custom-pagination .v-pagination__navigation {
  height: 28px;
  min-width: 28px;
  margin: 0px 4px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>
